import React, { FunctionComponent } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faSkype,
  faLinkedinIn
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import Icon from '@iconify/react/src/icon';
import upworkIcon from '@iconify/icons-simple-icons/upwork';
import { IEmployeeBoxPropsContact } from '../employee-box';
import styles from './social-media.module.scss';

export interface ISocialMediaIconProps {
  icon: string;
  className: string;
}

export const SocialMediaIcon: FunctionComponent<ISocialMediaIconProps> = props => {
  const { icon, className } = props;
  switch (icon) {
    case 'e-mail':
      return (
        <FontAwesomeIcon
          icon={faEnvelope}
          className={`${className} ${styles.email}`}
        />
      );
    case 'skype':
      return <FontAwesomeIcon icon={faSkype} className={className} />;
    case 'linkedin':
      return (
        <FontAwesomeIcon
          icon={faLinkedinIn}
          className={`${className} ${styles.linkedin}`}
        />
      );
    case 'facebook':
      return <FontAwesomeIcon icon={faFacebookF} className={className} />;
    case 'upwork':
      return <Icon icon={upworkIcon} className={className} />;
  }
};

export const properOrderForSocialMedia = (
  arrayOfSocialMediaContacts: IEmployeeBoxPropsContact[]
): IEmployeeBoxPropsContact[] => {
  const plannedOrder = ['e-mail', 'skype', 'linkedin', 'facebook', 'upwork'];
  const propperArray = [...arrayOfSocialMediaContacts];
  propperArray.sort(
    (a: IEmployeeBoxPropsContact, b: IEmployeeBoxPropsContact): number => {
      return plannedOrder.indexOf(a.icon) > plannedOrder.indexOf(b.icon)
        ? 1
        : -1;
    }
  );

  return propperArray;
};
